import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box, Grid } from '@mui/material';
import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { concatWithDot } from 'helpers/string';

import { GLOBAL_FIELD_NAMES, globalPrefix } from '../../Global/form';

export const FinancialInformationOverview = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.OVERVIEW,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_OVERVIEW.FINANCIAL_INFO,
  );

  return (
    <Box>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('overviewTitle')}
          badgeText={t('overview.financialInformation.title')}
        />
      </FormSectionCard>

      <FormSectionCard>
        <Grid container spacing={3} alignItems="end">
          <Grid item xs={6}>
            {/* 0.4.1 */}
            <NumberInputControlled
              control={control}
              id="overview.financialInformation.projectedAnnualIncome"
              name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PROJECTED_ANNUAL_INCOME)}
              label={t('overview.financialInformation.projectedAnnualIncome')}
              adornmentType="currency"
              disabled={!canAccess}
            />
          </Grid>
          <Grid item xs={6}>
            {/* 0.4.2 */}
            <NumberInputControlled
              control={control}
              id="overview.financialInformation.forecastedProfitability"
              name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.FORECASTED_PROFITABILITY)}
              label={t('overview.financialInformation.forecastedProfitability')}
              adornmentType="percentage"
              disabled={!canAccess}
            />
          </Grid>
          <Grid item xs={6}>
            {/* 0.4.3 */}
            <NumberInputControlled
              control={control}
              id="overview.financialInformation.projectedPlaybackPeriod"
              name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PROJECT_PAYBACK_PERIOD)}
              label={t('overview.financialInformation.projectedPlaybackPeriod')}
              disabled={!canAccess}
              maxLength={3}
            />
          </Grid>
        </Grid>
      </FormSectionCard>
    </Box>
  );
};
